/**
 * 房源管理路由
 */
export default {
  path: '/setup',
  name: 'setup',
  redirect: '/setup/financeSetup',
  component: () => import('../views/setup/index.vue'),
  meta: {
    headerTitle: '设置',
    icon: 'ab-iconfont ab-icon-setting-o',
    auth: 1011
  },
  children: [
    {
      path: 'financeSetup',
      name: 'financeSetup',
      component: () => import('../views/setup/financeSetup/index.vue'),
      meta: {
        headerTitle: '财务设置',
        icon: 'finance-setup'
      },
      props: {
        target: 'finance'
      }
    },
    {
      path: 'orderSetup',
      name: 'orderSetup',
      component: () => import('../views/setup/financeSetup/index.vue'),
      meta: {
        headerTitle: '订单设置',
        icon: 'order-setup'
      },
      props: {
        target: 'order'
      }
    },
    {
      path: 'staffSetUp',
      name: 'staffSetUp',
      component: () => import('../views/setup/staffSetUp/index.vue'),
      redirect: {
        name: 'staffList'
      },
      meta: {
        headerTitle: '员工管理',
        icon: 'staff-setup',
        noShowMenu: true
      },
      props: {
        target: 'staff'
      },
      children: [
        {
          path: '',
          name: 'staffList',
          component: () => import('../views/setup/staffSetUp/staffList.vue'),
          meta: {
            headerTitle: '员工管理'
          }
        },
        {
          path: 'new',
          name: 'createStaff',
          component: () => import('../views/setup/staffSetUp/staffOperation.vue'),
          meta: {
            headerTitle: '添加员工',
            hasBreadcrumb: true
          }
        },
        {
          path: ':id',
          name: 'staffDetail',
          component: () => import('../views/setup/staffSetUp/staffOperation.vue'),
          meta: {
            headerTitle: '查看',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        }
      ]
    }
  ]
}
